import type { Room } from '../../types/game'
import { useGameStore } from '../../store/gameStore'
interface JoinModalProps {
  selectedRoomId: string | null
  onSelect: (roomId: string) => void
  onJoin: () => void
  onBack: () => void
}

export function JoinModal({ selectedRoomId, onSelect, onJoin, onBack }: JoinModalProps) {
  const rooms = useGameStore((state) => state.lobbyRooms)
  const loaded = useGameStore((state) => state.lobbyRoomsLoaded)
  const visibleRows: Array<Room | null> = [
    ...rooms,
    ...Array.from({ length: Math.max(0, 5 - rooms.length) }, () => null),
  ]

  return (
    <>
      <div className="lobby-overlay" />
      <div className="lobby tableau">
        <div className="lobby-header">
          <div className="lobby-title">Lobby</div>
        </div>

        <div id="available-room-list">
          <div className="lobby-room-list-header">
            <div>Name</div>
            <div>Max Players</div>
            <div>Humans</div>
            <div>Bots</div>
          </div>
          {loaded ? (
            visibleRows.map((room, index) =>
              room ? (
                <div
                  key={room.id}
                  className={`lobby-room-row${room.id === selectedRoomId ? ' selected' : ''}`}
                  onClick={() => onSelect(room.id)}
                >
                  <div>{room.name}</div>
                  <div>{Object.values(room.slot_states).filter((slot) => slot !== 'closed').length}</div>
                  <div>{room.members.filter((member) => !member.is_bot).length}</div>
                  <div>{room.members.filter((member) => member.is_bot).length}</div>
                </div>
              ) : (
                <div key={`empty-${index}`} className="lobby-room-row empty">
                  <div>&nbsp;</div>
                  <div>&nbsp;</div>
                  <div>&nbsp;</div>
                  <div>&nbsp;</div>
                </div>
              )
            )
          ) : (
            <div className="lobby-room-row empty">
              <div>Loading...</div>
              <div>&nbsp;</div>
              <div>&nbsp;</div>
              <div>&nbsp;</div>
            </div>
          )}
        </div>

        <div className="lobby-start-container">
          <div id="join-back-button" className="lobby-start" onClick={onBack}>
            Back
          </div>
          <div
            id="join-selected-room-button"
            className={`lobby-start${selectedRoomId ? '' : ' disabled'}`}
            onClick={selectedRoomId ? onJoin : undefined}
          >
            Join
          </div>
        </div>
      </div>
    </>
  )
}
